import { NetworkInstance } from '@/components/AppContext'
import {
  Action,
  ActionList,
  ActionShortcuts,
  ActionV2,
  AppShare,
  ContentCollection,
  HeroArticle,
  HeroContent,
  HeroSong,
  HeroVideo,
  MenuAppVersion,
  MenuLogin,
  MenuNotification,
  MiniMandir,
  Panchang,
  SongPlaylist,
  YoutubeLive,
  YoutubeSchedule,
} from '@/entities/feeds/Widgets'
import Greeting from '@/entities/feeds/Widgets/Greeting'
import Social from '@/entities/feeds/Widgets/Social'
import Feeds from '@/network/Feeds/Feeds'
import FeedsRiddler from '@/network/Feeds/FeedsRiddler'
import { message } from 'antd'
import Cookies from 'js-cookie'
import moment from 'moment'

import { IUserProfile, LoginState } from '../entities/UserProfile'
import Property from '../entities/feeds/Property'
import { A4B_APPS, A4B_APPS_TYPES } from './constants'
import { Content } from './types'
import { getAllDays } from './utilProps'

let window = (global as any).window
export const extractBasicProfile = (identity: any) => {
  try {
    let profileData: IUserProfile = {
      loginStatus: identity?.email_verified
        ? LoginState.LOGGED_IN
        : LoginState.LOGGED_OUT,
      name: identity.name,
      email: identity.email,
      imageUrl: identity.picture,
    }
    return profileData
  } catch (error) {}
}

export const loadGAuthApi = async () => {
  let gapi = (global as any).gapi
  await gapi?.auth2?.init({
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    ux_mode: 'popup',
    scope: 'profile email',
  })
}

export const logoutUser = () => {
  Cookies.remove('gauth-token')
  localStorage.removeItem('userinfo')
  window.location.href = '/'
}

export const isCreateRoute = (urlPath: string): boolean => {
  let pathName = urlPath?.substring(1)
  let urlList = pathName?.split('/')
  return urlList[urlList.length - 1] === 'create' ? true : false
}
export const parseQueryString = (url: string) => {
  const queryString = url.replace(/.*\?/, '')

  if (queryString === url || !queryString) {
    return null
  }

  const urlParams = new URLSearchParams(queryString)
  const result: any = {}

  urlParams.forEach((val, key) => {
    if (result.hasOwnProperty(key)) {
      result[key] = [result[key], val]
    } else {
      result[key] = val
    }
  })

  return result
}
export const getWidgetEntityInstance = (widgetType: string): Content => {
  switch (widgetType) {
    case 'ACTION':
      return new Action()
    case 'APP_SHARE':
      return new AppShare()
    case 'YOUTUBE_SCHEDULE':
      return new YoutubeSchedule()
    case 'PANCHANG':
      return new Panchang()
    case 'HERO_SONG':
      return new HeroSong()
    case 'MINI_MANDIR':
      return new MiniMandir()
    case 'HERO_ARTICLE':
      return new HeroArticle()
    case 'HERO_CONTENT':
      return new HeroContent()
    case 'SONG_PLAYLIST':
      return new SongPlaylist()
    case 'YOUTUBE_LIVE':
      return new YoutubeLive()
    case 'CONTENT_COLLECTION':
      return new ContentCollection()
    case 'HERO_VIDEO':
      return new HeroVideo()
    case 'MENU_NOTIFICATION':
      return new MenuNotification()
    case 'ACTION_LIST':
      return new ActionList()
    case 'ACTION_SHORTCUTS':
      return new ActionShortcuts()
    case 'MENU_APP_VERSION':
      return new MenuAppVersion()
    case 'MENU_LOGIN':
      return new MenuLogin()
    case 'ACTION_V2':
      return new ActionV2()
    case 'HERO_SOCIAL_COMMUNITY':
      return new Social()
    case 'GREETING':
      return new Greeting()
    default:
      return new Action()
  }
}
export const getWidgetsNameAndClass = (widgetType: string) => {
  switch (widgetType) {
    case 'ACTION':
      return ['Action Widget', Action]
    case 'APP_SHARE':
      return ['App Share Widget', AppShare]
    case 'YOUTUBE_SCHEDULE':
      return ['Youtube Schedule Widget', YoutubeSchedule]
    case 'PANCHANG':
      return ['Panchang Widget', Panchang]
    case 'HERO_SONG':
      return ['Hero Song Widget', HeroSong]
    case 'MINI_MANDIR':
      return ['Mini Mandir Widget', MiniMandir]
    case 'HERO_ARTICLE':
      return ['Hero Article Widget', HeroArticle]
    case 'HERO_CONTENT':
      return ['Hero Content Widget', HeroContent]
    case 'SONG_PLAYLIST':
      return ['Song Playlist Widget', SongPlaylist]
    case 'YOUTUBE_LIVE':
      return ['Youtube Live Widget', YoutubeLive]
    case 'CONTENT_COLLECTION':
      return ['Content Collection Widget', ContentCollection]
    case 'HERO_VIDEO':
      return ['Hero Video Widget', HeroVideo]
    case 'MENU_NOTIFICATION':
      return ['Menu Notification Widget', MenuNotification]
    case 'ACTION_LIST':
      return ['Action List Widget', ActionList]
    case 'ACTION_SHORTCUTS':
      return ['Action Shortcuts Widget', ActionShortcuts]
    case 'MENU_APP_VERSION':
      return ['Menu App Version Widget', MenuAppVersion]
    case 'MENU_LOGIN':
      return ['Menu Login Widget', MenuLogin]
    case 'ACTION_V2':
      return ['Action V2 Widget', ActionV2]
    case 'HERO_SOCIAL_COMMUNITY':
      return ['Social Widget', Social]
    case 'GREETING':
      return ['Greeting Widget', Greeting]
    default:
      return []
  }
}
export const getReadableWidgetName = (widgetType: string) => {
  switch (widgetType) {
    case 'ACTION':
      return 'Action'
    case 'APP_SHARE':
      return 'App Share'
    case 'YOUTUBE_SCHEDULE':
      return 'Youtube Schedule'
    case 'PANCHANG':
      return 'Panchang'
    case 'HERO_SONG':
      return 'Hero Song'
    case 'MINI_MANDIR':
      return 'Mini Mandir'
    case 'HERO_ARTICLE':
      return 'Hero Article'
    case 'HERO_CONTENT':
      return 'Hero Content'
    case 'SONG_PLAYLIST':
      return 'Song Playlist'
    case 'YOUTUBE_LIVE':
      return 'Youtube Live'
    case 'CONTENT_COLLECTION':
      return 'Content Collection'
    case 'HERO_VIDEO':
      return 'Hero Video'
    case 'MENU_NOTIFICATION':
      return 'Menu Notification'
    case 'ACTION_LIST':
      return 'Action List'
    case 'ACTION_SHORTCUTS':
      return 'Action Shortcuts'
    case 'MENU_APP_VERSION':
      return 'Menu App Version'
    case 'MENU_LOGIN':
      return 'Menu Login'
    case 'ACTION_V2':
      return 'Action V2'
    case 'HERO_SOCIAL_COMMUNITY':
      return 'Social Community'
    case 'GREETING':
      return 'Greetings'
    default:
      return []
  }
}
export const isErrorPresent = (errorList: any[]) => {
  return errorList.some(item =>
    item && item.errors && item.errors.length ? true : false,
  )
}
export const cyclicDurationSerialize = (cyclic_duration: any) => {
  return Number(cyclic_duration.format('ss'))
}
export const cyclicDurationDeSerialize = (cyclic_duration: any) => {
  return moment(cyclic_duration, 'ss')
}

export const getQueryParamByObject = (filtersData: any) => {
  let keys = Object.keys(filtersData)
  let searchParams = ''
  for (let key of keys) {
    if (Array.isArray(filtersData[key])) {
      let duplicateQuery = ''
      let query = filtersData[key].map((item: string) => {
        return `${key}=${item}`
      })
      duplicateQuery = query.join('&')
      searchParams =
        searchParams === ''
          ? duplicateQuery
          : `${searchParams}&${duplicateQuery}`
    } else {
      searchParams =
        searchParams === ''
          ? `${key}=${filtersData[key]}`
          : `${searchParams}&${key}=${filtersData[key]}`
    }
  }
  return searchParams
}
export const getTimeInSecond = (time: string) => {
  let [hour, minute] = time.split(':')
  return Number(hour) * 3600 + Number(minute) * 60
}

export const getAllDaysSelectionValues = (
  value: string[],
  previousValue: string[],
) => {
  if (
    !value.includes('All') &&
    value.length === 7 &&
    previousValue.includes('All')
  ) {
    return { validDays: [], returnFlag: true }
  }
  if (
    (value.includes('All') && !previousValue.includes('All')) ||
    (!value.includes('All') && value.length === 7)
  ) {
    let days = [...getAllDays, 'All']
    return { validDays: days, returnFlag: true }
  }

  if (value.includes('All') && value.length <= 8) {
    let allRemoved: string[] = value.filter(item => item !== 'All')
    return { validDays: allRemoved, returnFlag: true }
  }
  if (
    value.includes('All') &&
    value.length === 7 &&
    previousValue.includes('All')
  ) {
    let days = [...getAllDays, 'All']
    return { validDays: days, returnFlag: true }
  }

  return { validDays: value, returnFlag: false }
}

export const throwError = (message: string) => {
  throw new Error(message)
}

export const masterWidgetOptions = (master_widgets: any[]): any[] => {
  let options = master_widgets?.map((item: Property) => ({
    value: item,
    label: item,
  }))
  return options?.length ? options : []
}
export const referenceCodeValidator = async (rule: any, value: any) => {
  if (!value) return Promise.reject('Reference code required!')
  let pattern = /^(?:[A-Z0-9]+_{0,1})+[A-Z0-9]+$/i
  if (!pattern.test(value)) {
    return Promise.reject(
      'Reference code must be only alphanumeric and underscore will be allowed in the middle.',
    )
  }
  if (value && value.length > 64) {
    return Promise.reject(
      'Reference code must be lessthan or equal to 64 chars',
    )
  }
}
export const getFeedsCarnageInstance = (apiInstance: any): Feeds =>
  new Feeds(apiInstance)
export const getFeedsRiddlerInstance = (apiInstance: any): FeedsRiddler =>
  new FeedsRiddler(apiInstance)

export const getRiddlerCdnAbsoluteUrl = (content: any) =>
  `${process.env.REACT_APP_RIDDLER_CDN_API_URL}/${content?.s3_path}`

/**
 * Changes camel case to a human readable format. So helloWorld, hello-world and hello_world becomes "Hello World".
 * */
export const prettifyCamelCase = (value = ''): string => {
  let output = ''
  const len = value.length
  let char: string

  for (let i = 0; i < len; i += 1) {
    char = value.charAt(i)

    if (i === 0) {
      output += char.toUpperCase()
    } else if (char !== char.toLowerCase() && char === char.toUpperCase()) {
      output += ` ${char}`
    } else if (char === '-' || char === '_') {
      output += ' '
    } else {
      output += char
    }
  }

  return output
}

export const b64DecodeUnicode = (str: string) =>
  decodeURIComponent(
    Array.prototype.map
      .call(
        atob(str),
        c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2),
      )
      .join(''),
  )

export const parseJwt = (token: string) =>
  JSON.parse(
    b64DecodeUnicode(token.split('.')[1].replace('-', '+').replace('_', '/')),
  )

export function isValidHttpUrl(path: string) {
  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ) // fragment locator
  return !!pattern.test(path)
}

export const titleCase = (s: string) =>
  s.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
    c ? c.toUpperCase() : ' ' + d.toUpperCase(),
  )

export const formatDateToIsoString = (formDate: any) => {
  const processDate = new Date(formDate)
  let processed_date
  if (isNaN(processDate.getTime())) {
    processed_date = new Date()
  } else {
    processed_date = new Date(formDate)
  }
  return processed_date.toISOString()
}

export const formatDateToISTIsoString = (formDate: any) => {
  // Handle null/undefined case first
  if (!formDate) return null

  const processDate = new Date(formDate)
  // Check for invalid date or the specific 0001-01-01 case
  if (isNaN(processDate.getTime())) {
    return formatCurrentDateToIST()
  }

  // Check if year is 0001 (handles various string formats)
  if (
    processDate.getFullYear() === 1 ||
    (typeof formDate === 'string' && formDate.includes('0001-01-01'))
  ) {
    return formatCurrentDateToIST()
  }

  // Format the valid date
  const pad = (n: number) => n.toString().padStart(2, '0')

  const year = processDate.getFullYear()
  const month = pad(processDate.getMonth() + 1)
  const date = pad(processDate.getDate())
  const hours = pad(processDate.getHours())
  const minutes = pad(processDate.getMinutes())
  const seconds = pad(processDate.getSeconds())

  return `${year}-${month}-${date}T${hours}:${minutes}:${seconds}+05:30`
}

// Helper function to format current date in IST
const formatCurrentDateToIST = () => {
  const now = new Date()
  const pad = (n: number) => n.toString().padStart(2, '0')

  const year = now.getFullYear()
  const month = pad(now.getMonth() + 1)
  const date = pad(now.getDate())
  const hours = pad(now.getHours())
  const minutes = pad(now.getMinutes())
  const seconds = pad(now.getSeconds())

  return `${year}-${month}-${date}T${hours}:${minutes}:${seconds}+05:30`
}

export const formatJson = (jsonString: string | object) => {
  try {
    if (typeof jsonString === 'string') {
      const parsedJson = JSON.parse(jsonString)
      return JSON.stringify(parsedJson, null, '\t')
    }
    return JSON.stringify(jsonString, null, '\t')
  } catch (e) {
    return jsonString
  }
}

export const downloadVideo = async (mediaUrl: string, fileName: string) => {
  try {
    const response = await fetch(mediaUrl)

    if (!response.ok) {
      throw new Error('Failed to fetch the video')
    }

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.mp4`)

    document.body.appendChild(link)

    message.destroy()
    message.loading('Download started!', 3)
    message.info('Check browser downloads for status.', 3)

    link.click()

    window.URL.revokeObjectURL(url)
    document.body.removeChild(link)
  } catch (error) {
    message.destroy()
    message.error('Video download failed', 3)
    console.error('Failed to download video', error)
  }
}

export function extractMediaUrls(
  obj: any,
  medias?: string[],
  parentKey?: string,
): any {
  if (typeof obj === 'object' && obj !== null) {
    // Check if this object is a store item (has media_list, media_thumbnail, and media_type)
    if (
      obj.media_list &&
      Array.isArray(obj.media_list) &&
      obj.media_thumbnail !== undefined &&
      obj.media_type
    ) {
      const mediaListArray = obj.media_list
      const mediaThumbnail = obj.media_thumbnail
      const mediaType = obj.media_type

      obj.media_list = mediaListArray.map((mediaUrl: string) => ({
        media_url: mediaUrl,
        media_thumbnail: mediaThumbnail || '',
        media_type: mediaType || '',
      }))

      // Remove the top-level media_thumbnail and media_type as they're now inside media_list
      delete obj.media_thumbnail
      delete obj.media_type
    }

    for (const key in obj) {
      if (medias?.includes(key) && Array.isArray(obj[key])) {
        obj[key] = obj[key]?.[0]
      } else if (typeof obj[key] === 'object') {
        extractMediaUrls(obj[key], medias, key)
      }
    }
  }
  return obj
}

export function convertMediaUrlsToArrays(obj: any, medias?: string[]): any {
  if (typeof obj === 'object' && obj !== null) {
    for (const key in obj) {
      if (medias?.includes(key) && typeof obj[key] === 'string') {
        obj[key] = [obj[key]]
      } else if (typeof obj[key] === 'object') {
        convertMediaUrlsToArrays(obj[key], medias)
      }
    }
  }
  return obj
}

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (error) {
    console.error('Failed to copy text to clipboard:', error)
    return false
  }
}

export const showErrorToast = (error: any, duration = 3) => {
  message.error(`${error?.response?.data?.error?.message}`, duration)
}

export const getMonetisationPujaApi = (
  app: A4B_APPS_TYPES | null,
  networkInstance: NetworkInstance,
) => {
  return app === A4B_APPS.SRIMANDIR
    ? networkInstance.clientWithHeaders.monetisationPujaApi
    : networkInstance.clientWithHeaders.monetisationAstroPujaApi
}

export const formatDateToIsoStringTime = (formDate: any) => {
  let processed_date

  if (formDate && formDate._isAMomentObject) {
    const clonedMoment = formDate.clone()

    if (!clonedMoment.isUTC()) {
      clonedMoment.add(5, 'hours').add(30, 'minutes')
    }
    processed_date = clonedMoment.toDate()
  } else {
    processed_date = new Date(formDate)
  }

  return processed_date.toISOString() // Default UTC format
}

export const formatDateToIstIsoString = (momentDate: any) => {
  if (!momentDate || !momentDate._isAMomentObject) return null
  const istIsoFormat = momentDate.format('YYYY-MM-DDTHH:mm:ss+05:30')
  return istIsoFormat
}

export const formatDateToMomentUtc = (
  date: string,
  offset: number | string = 0,
): moment.Moment => {
  const formattedDate = moment(
    moment(date).format('YYYY-MM-DD HH:mm:ss'),
  ).utcOffset(offset)
  return formattedDate
}

export const getMediaExtension = (path: string) => {
  const fileUrl = path
  const fileExtension = fileUrl?.split?.('.')?.pop?.()
  return fileExtension
}

export const getFileFormat = (fileExtension: string): string | null => {
  const normalizedExtension = fileExtension?.toLowerCase()

  const imageExtensions = ['jpg', 'jpeg', 'png', 'webp', 'gif']
  const videoExtensions = ['mp4']

  if (imageExtensions?.includes?.(normalizedExtension)) {
    return 'image'
  } else if (videoExtensions?.includes?.(normalizedExtension)) {
    return 'video'
  } else {
    return null
  }
}

export const deityOptions = [
  { value: 'suryadev', label: 'Lord Surya Dev' },
  { value: 'shiva', label: 'Lord Shiva' },
  { value: 'hanuman', label: 'Lord Hanuman' },
  { value: 'ganesh', label: 'Lord Ganesh' },
  { value: 'vishnu', label: 'Lord Vishnu' },
  { value: 'matadurga', label: 'Mata Durga' },
  { value: 'shanidev', label: 'Lord Shani Dev' },
]
export const rashiOptions = [
  { value: 'aries', label: 'Aries (Mesh)' },
  { value: 'taurus', label: 'Taurus (Vrishabh)' },
  { value: 'gemini', label: 'Gemini (Mithun)' },
  { value: 'cancer', label: 'Cancer (Kark)' },
  { value: 'leo', label: 'Leo (Simha)' },
  { value: 'virgo', label: 'Virgo (Kanya)' },
  { value: 'libra', label: 'Libra (Tula)' },
  { value: 'scorpio', label: 'Scorpio (Vrishchik)' },
  { value: 'sagittarius', label: 'Sagittarius (Dhanu)' },
  { value: 'capricorn', label: 'Capricorn (Makar)' },
  { value: 'aquarius', label: 'Aquarius (Kumbh)' },
  { value: 'pisces', label: 'Pisces (Meen)' },
]
export const getDayFromDate = (dateString: string): string | null => {
  if (!dateString) return null
  const date = new Date(dateString)
  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]
  return days[date.getDay()]
}

export const getCurrentMonthYear = () => {
  const currentDate = new Date()
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
  const year = currentDate.getFullYear().toString()
  return month + year
}
interface OptionType {
  id: string
  name: string
}
export const processThithiOptions = (calendarDays: any[]): OptionType[] => {
  const uniqueThithis = new Set<string>()
  const thithiData: OptionType[] = []

  calendarDays.forEach((day, index) => {
    if (day?.local_day_name && !uniqueThithis.has(day.local_day_name)) {
      uniqueThithis.add(day.local_day_name)
      thithiData.push({
        id: index.toString(),
        name: day.local_day_name,
      })
    }
  })

  return thithiData
}

// export const processFestivalOptions = (calendarDays: any[]): OptionType[] => {
//   const uniqueFestivals = new Set<string>()
//   const festivalData: OptionType[] = []

//   calendarDays.forEach((day, index) => {
//     if (day?.festivals?.length > 0) {
//       const combinedFestival = day.festivals.join('__')
//       if (!uniqueFestivals.has(combinedFestival)) {
//         uniqueFestivals.add(combinedFestival)
//         festivalData.push({
//           id: `festival_${index}`,
//           name: combinedFestival,
//         })
//       }
//     }
//   })

//   return festivalData
// }

export const processFestivalOptions = (calendarDays: any[]): OptionType[] => {
  const uniqueFestivals = new Set<string>()
  const festivalData: OptionType[] = []

  calendarDays.forEach(day => {
    if (Array.isArray(day?.festivals)) {
      day.festivals.forEach((festival: string) => {
        if (!uniqueFestivals.has(festival)) {
          uniqueFestivals.add(festival)
          festivalData.push({
            id: `festival_${festival.replace(/\s+/g, '_').toLowerCase()}`,
            name: festival,
          })
        }
      })
    }
  })

  return festivalData
}
